export const DISPATCH_TIME = "Dispatch Time"
export const CART_ID = "Cart ID"
export const ROUTE_ID = "Route ID"
export const STAGE_BY_TIME = "Stage By Time"
export const LOCATION_CART_VIEW = "Staging Location"
export const LOCATION = "Location"
export const STATUS = "Status"
export const DWELL_DURATION = "Dwell Duration"
export const STAGE_TIME = "Stage Time"
export const ASSOCIATE = "Associate"
export const STATION_PAIRS = "Pick Station"
export const ROUTE_TYPE = "Type"

export const CART_VIEW_TABLE_COLUMNS_AR = [
    CART_ID,
    ROUTE_ID,
    STAGE_BY_TIME,
    LOCATION_CART_VIEW,
    STATUS,
    DWELL_DURATION,
    ASSOCIATE,
    STATION_PAIRS,
    ROUTE_TYPE,
]

export const CART_VIEW_TABLE_COLUMNS_AMZL = [
    DISPATCH_TIME,
    CART_ID,
    ROUTE_ID,
    LOCATION,
    STATUS,
    DWELL_DURATION,
    STAGE_TIME,
    ASSOCIATE,
    ROUTE_TYPE,
]


// WEBPACK FOOTER //
// ./src/components/routeStageStatus/CartViewTableColumns.js